import { render, staticRenderFns } from "./Businesscard.vue?vue&type=template&id=b23cde42&"
import script from "./Businesscard.vue?vue&type=script&lang=js&"
export * from "./Businesscard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports